import React, {Component} from 'react';
import {
    Col,
    Form,
    FormGroup,
    FormText,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledTooltip
} from 'reactstrap';
import Notify from 'react-notification-alert';
import {formattedNumber, humanReadableByteCount2, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import * as moment from "moment";
import Datetime from "react-datetime/DateTime";
import 'react-datetime/css/react-datetime.css';
import Select from "../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import NumberFormat from 'react-number-format';
import Alert from "react-s-alert";
import * as _ from "lodash";
import {EntegratorIdentifiers} from "../../../helper/enums";
import {EntegratorConf, VirtualHost} from "../../../constants";
import {chooseFromList, defterUnitIsPage, defterUnitName, defterUnitNameShort} from "../../../helper/permission";

class CreditModal extends Component {

    constructor(props) {
        super(props);

        this.state =
            {
                modal: false,
                result: null,
                code: null,
                creditData: {
                    birimTuru: "FATURA_ADEDI",
                    islemTuru: "SATINALMA",
                    baslangicTarihi: moment().format("YYYY-MM-DD"),
                    sonKullanimTarihi: moment().add(([EntegratorIdentifiers.MIKROKOM, EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(EntegratorConf.identifier) ? 2 : 1), 'y').format("YYYY-MM-DD"),
                    birimMiktari: 0,
                    odemeTuru: "PESIN",
                    faturaNo: (this.props.currentUser.distributor && this.props.currentUser.workType ===3)  ? "BAYITOPLUSATINALMA" : "",
                    taksitSayisi: 0,
                    fiyat: 0.0,
                    hediyeTuru : null,
                    aciklama: null
                },
                amountList: [],
                amountMbList: [],
                chooseAmountFromList: true,
                processing: false,
                error: {},
                giftTypeList :[]
            };

        this.toggleModal = this.toggleModal.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
        this.unitTypeExpr = this.unitTypeExpr.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.validateCreditData = this.validateCreditData.bind(this);
        this.onSave = this.onSave.bind(this);
        this.fetchGiftTypes = this.fetchGiftTypes.bind(this);
    }

    componentDidMount() {
        let {priceAmountMap, priceAmountMbMap} = this.props;

        let amountList = [];
        let amountMbList = [];

        if(priceAmountMap && priceAmountMap.length>0){
            amountList = priceAmountMap.map(item =>{
                return {
                    value: parseInt(item.amount),
                    label: formattedNumber(item.amount)
                }
            })
        }
        if(priceAmountMbMap && priceAmountMbMap.length>0){
            amountMbList = priceAmountMbMap.map(item =>{
                return {
                    value: parseInt(item.amount),
                    label: (defterUnitIsPage(EntegratorConf.identifier) ? formattedNumber(item.amount) : humanReadableByteCount2(item.amount*1048576))
                }
            })
        }
        this.fetchGiftTypes();

        this.setState({
            modal: this.props.modal,
            amountList: amountList,
            amountMbList: amountMbList
        });
    }

    fetchGiftTypes() {
        let self = this;
        let params = {
            url: '/customer/getGiftTypes',
            method: "get",
        };
        request(params)
            .then(function (response) {
                let giftTypeList = response.data;
                giftTypeList = giftTypeList.map(data => ({
                    value: data.name,
                    label: data.name
                }));
                self.setState({giftTypeList});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    toggleModal() {
        this.props.toggle();
    }

    unitTypeExpr(unitType) {
        return (unitType === "FATURA_ADEDI" || unitType === "ARSIV_KASA") ? "Adet" : (defterUnitNameShort(EntegratorConf.identifier))
    }

    validateCreditData() {
        let {creditData} = this.state;
        let message = "";
        let valid = true;
        if (creditData["islemTuru"] ===  "HEDIYE" && !creditData["aciklama"] && this.showGiftFields()) {
            message = message + `Açıklama alanı boş olamaz.</br>`;
            valid = false;
        }
        if (creditData["islemTuru"] ===  "HEDIYE" && !creditData["hediyeTuru"] && this.showGiftFields()) {
                message = message + `Hediye Türü alanı boş olamaz.</br>`;
                valid = false;
        }
        if(creditData["islemTuru"] === "TRANSFER" && (!creditData["aciklama"])  && this.showGiftFields()){
            message = message + `Açıklama alanı boş olamaz.</br>`;
            valid = false;
        }
        return {valid: valid, message: message};
    }

    onSave() {
        let self = this;
        let result = this.validateCreditData();

        let {creditData} = this.state;
        let customerId = this.props.customer.recordId;

        let params = {
            url: `/customer/addCredit/${customerId}`,
            method: 'post',
            data: creditData
        };

        this.setState({processing: true});

        if (result.valid) {
            if (!(creditData.islemTuru === "SATINALMA" && creditData.fiyat === 0)) {
                request(params).then(function (response) {

                    Alert.success(response.data, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                    self.props.toggle();

                }).catch(function (error) {

                    let errorMessage = error.response.data;

                    if (error.response.data.Exception) errorMessage = error.response.data.Exception;
                    if (error.response.data.Error) errorMessage = error.response.data.Error;

                    self.setState({processing: false});
                    self.refs.notify.notificationAlert({
                        place: 'tr',
                        message: errorMessage,
                        type: 'danger',
                        autoDismiss: 5,
                    });
                });
            } else {
                Alert.error("Fiyat 0₺'den büyük olmalıdır.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({processing: false});
            }
        }else {
            Alert.error(result.message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000,
                html: true
            });
            self.setState({processing: false})
            return;
        }
    }
    onBuy = async () =>{
        let self = this;
        let payTrOrder = {};
        const creditData = this.state.creditData;
        if(creditData.fiyat === 0 ){
            Alert.error("Fiyat 0₺'den büyük olmalıdır.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
            self.setState({processing: false});
        }else{
            payTrOrder.merchantFailUrl  = window.location.origin;
            payTrOrder.merchantOkUrl    = window.location.origin;
            payTrOrder.clientCustomer = this.props.customer;
            payTrOrder.paymentType = "PAY_FOR_CUSTOMER";
            let unit;
            if(creditData.birimTuru === "FATURA_ADEDI"){
                unit = 1;
            }else if(creditData.birimTuru === "ALAN_BOYUTU"){
                unit = 2;
            }else if(creditData.birimTuru === "ARSIV_KASA"){
                unit = 3;
            }
            let price = 0;
            if(typeof creditData.fiyat === 'object'){
                price = (1-(creditData.factor? creditData.factor:0))*creditData.fiyat.price
            }else{
                price = (1-(creditData.factor? creditData.factor:0))*creditData.fiyat
            }
            payTrOrder.payTrOrderLines  = [{
                unit,
                count:creditData.birimMiktari,
                price:price
            }];
            let params = {
                url:"/payTrOrder/save",
                method: "post",
                data: payTrOrder
            };
            self.setState({processing: true});
            try {
                const response = await request(params);
                Alert.success("Yönlendiriliyorsunuz...", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000,
                    html:false
                });
                setTimeout(function () {
                    window.location.href = self.props.currentUser.paytrDomain + "/external/"+response.data.merchantOid;
                }, 100);
            }catch (error){
                showAxiosError(error);
            }
            self.setState({processing: false});
        }


    }

    checkDateValidity(current, field) {
        let now = moment().subtract(1, "days");
        if (field === 'baslangicTarihi') {
            return current.isSameOrAfter(now);
        }
        if (field === 'sonKullanimTarihi') {
            let startDate = moment(this.state.creditData.baslangicTarihi);
            return current.isAfter(startDate);
        }
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.query();
        }
    }

    onInput(e) {
        if (!e.target.validity.valid) {
            return;
        }
        const {value, name} = e.target;
        let {creditData, error} = this.state;

        creditData[name] = value;

        if (creditData.taksitSayisi === null) {
            error["taksitSayisi"] = {className: "is-invalid", message: "Bu alan zorunludur."}
        } else if (creditData.taksitSayisi <= 0) {
            error["taksitSayisi"] = {className: "is-invalid", message: "Taksit sayısı pozitif bir sayı olmalıdır."}
        } else {
            error["taksitSayisi"] = undefined
        }
        this.setState({creditData, error})
    }

    onValueChange = (e, id) => {
        let {creditData} = this.state;
        const {value} = e;

        let {priceAmountMap,priceAmountMbMap,currentUser} = this.props;
        if(id==="birimMiktari" && currentUser.workType === 2){
            if(creditData.birimTuru === "FATURA_ADEDI" || creditData.birimTuru === "ARSIV_KASA"){
                creditData.fiyat = value*priceAmountMap[0].price/priceAmountMap[0].amount;
                creditData.factor = priceAmountMap[0].factor;
            }else if(creditData.birimTuru === "ALAN_BOYUTU"){
                creditData.fiyat = value*priceAmountMbMap[0].price/priceAmountMbMap[0].amount;
                creditData.factor = priceAmountMbMap[0].factor;
            }

        }

        creditData[id] = value;
        this.setState({creditData});
    }

    onChange(e) {
        if (!e) {
            return;
        }

        const value = e.target.value;
        const fieldName = e.target.name;
        let {creditData} = this.state;

        creditData[fieldName] = value;
        this.setState({creditData})
    }

    onChangeDate(momentObj, type, fieldName) {

        let value;
        let {creditData, error} = this.state;
        if (!(typeof momentObj === "string")) {

            value = momentObj.format("YYYY-MM-DD");
            error[fieldName] = undefined

        } else {
            value = momentObj;
            error[fieldName] = {className: "is-invalid", message: "Tarih formatı hatalı. GG-AA-YYYY biçimine uyunuz."}

        }
        creditData[fieldName] = value;
        this.setState({creditData, error})
    }

    unitTypeList() {
        return [
            {value: "FATURA_ADEDI", label: "Kontör"},
            {value: "ALAN_BOYUTU", label: defterUnitName(EntegratorConf.identifier)},
            {value: "ARSIV_KASA", label: "Arşiv Kasa"}
        ]
    }

    paymentTypeList() {
        return [
            {value: "PESIN", label: "Peşin"},
            {value: "TAKSIT", label: "Taksitli"},
            {value: "UCRETSIZ", label: "Ücretsiz"}
        ];
    }

    operationTypeList() {
        if (
            EntegratorConf.identifier === EntegratorIdentifiers.BYM &&
            this.props.currentUser.isDistributor
        ) {
            return [{ value: "SATINALMA", label: "Satın Alma" }];
        }
        return [
            { value: "SATINALMA", label: "Satın Alma" },
            { value: "HEDIYE", label: "Hediye" },
            { value: "TRANSFER", label: "Transfer" }
        ];
    }



    onSelect(field, selected) {
        let {creditData} = this.state;
        const {chooseAmountFromList} = this.state;
        creditData[field] = selected;

        if (field === "islemTuru" && selected === "SATINALMA") {
            creditData["odemeTuru"] = "PESIN";
        } else if (field === "islemTuru" && (selected === "HEDIYE" || selected === "TRANSFER")) {
            creditData["odemeTuru"] = "UCRETSIZ";
        }

        if (field === "odemeTuru") {
            if (selected === "TAKSIT") {
            } else {
                creditData["taksitSayisi"] = null;
            }
        }
        if(field === "islemTuru" && selected !== "HEDIYE"){
            creditData["hediyeTuru"] = null;
            creditData["aciklama"] = null;
        }

        if (field === "birimMiktari") {
            let obj = this.getPriceForAmount(creditData[field]);
            creditData["fiyat"] = obj.price;
            creditData["factor"] = obj.factor;
        }

        if (field === "birimTuru") {
            const birimTuru = creditData["birimTuru"];
            if (!this.isPriceAmountMapEmpty(birimTuru)) {
                if (chooseAmountFromList === true) {
                    creditData["birimMiktari"] = this.getProperFirstElement(birimTuru).value;
                    let obj = this.getPriceForAmount(creditData["birimMiktari"])
                    creditData["fiyat"] = obj.price;
                    creditData["factor"] = obj.factor;
                }
            }
            creditData["birimMiktari"] = 0;
            creditData["fiyat"] = 0;
        }

        this.setState({creditData})
    }

    getProperFirstElement(unitType) {
        const {amountList, amountMbList} = this.state;
        switch (unitType) {
            case "FATURA_ADEDI":
            case "ARSIV_KASA":
                return amountList[0];
            case "ALAN_BOYUTU":
                return amountMbList[0];
            default:
                return 0;
        }
    }

    isPriceAmountMapEmpty(unitType) {
        const {priceAmountMap, priceAmountMbMap} = this.props;
        switch (unitType) {
            case "FATURA_ADEDI":
            case "ARSIV_KASA":
                return _.isEmpty(priceAmountMap)
            case "ALAN_BOYUTU":
                return _.isEmpty(priceAmountMbMap)
            default:
                return true;
        }
    }

    getPriceForAmount = (amount) => {

        const {priceAmountMap, priceAmountMbMap} = this.props;
        const {creditData} = this.state;
        const {birimTuru} = creditData;
        switch (birimTuru) {
            case "FATURA_ADEDI":
            case "ARSIV_KASA":
                return priceAmountMap.find(item => item.amount == amount);
            case "ALAN_BOYUTU":
                return priceAmountMbMap.find(item => item.amount == amount);
            default:
                return 0;
        }
    }


    onToggleChecker(e) {
        const target = e.target;
        const value = target.checked;
        let {creditData} = this.state;
        const birimTuru = creditData.birimTuru;

        if (value === true) {
            if (!this.isPriceAmountMapEmpty(birimTuru)) {
                creditData["birimMiktari"] = this.getProperFirstElement(birimTuru).value;
                if (typeof creditData["birimMiktari"] !== typeof undefined) {
                    if (typeof creditData["fiyat"] !== typeof undefined) {
                        let obj = this.getPriceForAmount(creditData["birimMiktari"])
                        creditData["fiyat"] = obj.price;
                        creditData["factor"] = obj.factor;
                    } else {
                        creditData["fiyat"] = 0;
                    }
                } else {
                    creditData["birimMiktari"] = 0;
                }
            } else {
                creditData["birimMiktari"] = 0;
            }
        }
        this.setState({chooseAmountFromList: value})
    }

    showGiftFields(){
        return ['smart','kolaysoft', 'mbtfatura'].includes(VirtualHost.conf.resourcePrefix);
    }

    render() {
        let error = this.state.error;
        let startDate = this.state.creditData.baslangicTarihi;
        let endDate = this.state.creditData.sonKullanimTarihi;
        let operationType = this.state.creditData.islemTuru;
        let paymentType = this.state.creditData.odemeTuru;
        let unitType = this.state.creditData.birimTuru;
        let quantity = this.state.creditData.birimMiktari;
        let price = this.state.creditData.fiyat;
        let layaways = this.state.creditData.taksitSayisi;
        let invoiceNumber =  this.state.creditData.faturaNo;
        let giftType = this.state.creditData.hediyeTuru;
        let explanation = this.state.creditData.aciklama;
        let chooseAmountFromList = this.state.chooseAmountFromList;
        let giftTypeList = this.state.giftTypeList;
        return (
            <Modal isOpen={this.state.modal} keyboard={true} size="lg">
                <Notify ref="notify"/>
                <ModalHeader toggle={this.toggleModal}>Kredi Yükle</ModalHeader>
                <ModalBody>
                    {this.state.processing &&
                    <div className="row" style={{backgroundColor: "#bbd7ea"}}><span className="pull-right">İşlem devam ediyor..</span>
                    </div>
                    }
                    <Form>
                        <Row>
                            <Col md={12}>
                                <Label style={{"fontSize": "17px"}}>{this.props.customer.vknTckn} VKN/TCKN'li müşteri
                                    için işlem yapmaktasınız.</Label>
                            </Col>
                            <Col md={12}>
                                {chooseFromList(this.props.currentUser.isEntegrator,EntegratorConf.identifier) &&
                                <Label check>
                                    <Input type="checkbox" name="chooseFromList"
                                           value={1}
                                           checked={!!chooseAmountFromList} bsSize={"15px"}
                                           disabled={!this.props.priceAmountMap}
                                           onChange={e => this.onToggleChecker(e)}/>{' '}
                                    Birim Miktarını liste fiyatlarından seç
                                </Label>
                                }
                            </Col>
                        </Row>
                        <hr style={{"color": "aliceblue"}}/>
                        <Row form="true">
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="islemTuru">İşlem Türü</Label>
                                    <Select
                                        id="islemTuru"
                                        name="islemTuru"
                                        value={this.state.creditData.islemTuru}
                                        clearable={false}
                                        placeholder="Seçiniz..."
                                        noResultsText="Kayıt bulunamadı."
                                        onChange={(e) => this.onSelect("islemTuru", e.value)}
                                        options={this.operationTypeList()} 
                                    />

                                </FormGroup>
                            </Col>
                            {(operationType === 'HEDIYE' && this.showGiftFields()) &&
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="hediyeTuru">Hediye Türü</Label>
                                    <Select id="hediyeTuru"
                                            clearable={true}
                                            name="hediyeTuru"
                                            value={giftType}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => this.onSelect("hediyeTuru", e ? e.value : null)}
                                            options={giftTypeList}
                                    />
                                </FormGroup>
                            </Col>
                            }
                            {((operationType === 'HEDIYE' || operationType === "TRANSFER") && this.showGiftFields()) &&
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="aciklama">Açıklama</Label>
                                    <Input type="text"
                                           onChange={this.onChange}
                                           value={explanation}
                                           ref="aciklama"
                                           name="aciklama"
                                           id="aciklama"/>
                                </FormGroup>
                            </Col>
                            }
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="birimTuru">Birim Türü</Label>
                                    <Select id="birimTuru"
                                            name="birimTuru"
                                            value={unitType}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => this.onSelect("birimTuru", e.value)}
                                            options={this.unitTypeList()}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="birimMiktari">Birim Miktarı <span
                                        style={{color: "crimson"}}>({this.unitTypeExpr(unitType)})</span>
                                        {!chooseAmountFromList && this.props.currentUser.workType === 2 &&
                                            <span>
                                                <i className="fa fa-question-circle" id="invoiceTags" style={{paddingLeft: '3px'}} aria-hidden="true"/>
                                                <UncontrolledTooltip placement="right" target={"invoiceTags"} delay={0}>
                                                    Fiyat listesindeki en küçük miktardan daha fazlasını elle giriş yapamazsınız.
                                                </UncontrolledTooltip>
                                            </span>

                                        }
                                    </Label>
                                    {
                                        chooseAmountFromList ?
                                            <Select id="birimMiktari"
                                                    name="birimMiktari"
                                                    value={quantity}
                                                    clearable={false}
                                                    placeholder="Seçiniz..."
                                                    noResultsText="Kayıt bulunamadı."
                                                    onChange={(e) => this.onSelect("birimMiktari", e.value)}
                                                    options={this.quantityList(unitType)}
                                            />
                                            :
                                            <NumberFormat id="birimMiktari"
                                                          value={quantity}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={0}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          isAllowed={values => {
                                                              if(this.props.currentUser.workType === 2 && (unitType === "FATURA_ADEDI" || unitType === "ARSIV_KASA")){
                                                                  return (this.state.amountList[0] && values.value < this.state.amountList[0].value);
                                                              }else if(this.props.currentUser.workType === 2 && unitType === "ALAN_BOYUTU"){
                                                                  return (this.state.amountList[0] && values.value < this.state.amountMbList[0].value);
                                                              }else{
                                                                  return (values.value !== "");
                                                              }
                                                          }}
                                                          placeholder=""
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={e => this.onValueChange(e, "birimMiktari")}
                                                          className="form-control"/>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="fiyat">Fiyat (₺)</Label>
                                    <NumberFormat id="fiyat"
                                                  value={typeof price === 'object'  ? price.price : price}
                                                  disabled={(this.props.currentUser && (this.props.currentUser.workType === 2 || this.props.currentUser.workType === 3))}
                                                  allowNegative={false}
                                                  isNumericString={true}
                                                  allowEmptyFormatting={false}
                                                  decimalScale={2}
                                                  thousandSeparator={'.'}
                                                  decimalSeparator={','}
                                                  displayType="input"
                                                  isAllowed={values => {
                                                      return (values.value !== "");
                                                  }}
                                                  placeholder=""
                                                  renderText={value => {
                                                      value.replace(/\./g, ',')
                                                  }}
                                                  onValueChange={e => this.onValueChange(e, "fiyat")}
                                                  className="form-control"/>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="baslangicTarihi">Başlangıç Tarihi</Label>
                                    <Datetime locale="tr"
                                              inputProps={{
                                                  id: "baslangicTarihi",
                                                  className: (error.baslangicTarihi ? error.baslangicTarihi.className + " form-control" : "form-control"),
                                                  disabled: this.props.currentUser.workType === 2
                                              }}
                                              className="datepicker"
                                              input={true}
                                              closeOnSelect={true}
                                              value={moment(startDate, "YYYY-MM-DD", true).isValid() ? moment(startDate).format("DD-MM-YYYY") : startDate}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={(current) => this.checkDateValidity(current, "baslangicTarihi")}
                                              onChange={(e) => this.onChangeDate(e, "date", "baslangicTarihi")}/>
                                    {error.baslangicTarihi &&
                                    <FormText className="text-danger">
                                        {error.baslangicTarihi.message}
                                    </FormText>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="sonKullanimTarihi">Son Kullanım Tarihi</Label>
                                    <Datetime locale="tr"
                                              inputProps={{
                                                  id: "sonKullanimTarihi",
                                                  className: (error.baslangicTarihi ? error.baslangicTarihi.className + " form-control" : "form-control"),
                                                  disabled: this.props.currentUser.workType === 2
                                              }}
                                              className="datepicker"
                                              input={true}
                                              closeOnSelect={true}
                                              value={moment(endDate, "YYYY-MM-DD", true).isValid() ? moment(endDate).format("DD-MM-YYYY") : endDate}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={(current) => this.checkDateValidity(current, "sonKullanimTarihi")}
                                              onChange={(e) => this.onChangeDate(e, "date", "sonKullanimTarihi")}/>
                                    {error.sonKullanimTarihi &&
                                    <FormText className="text-danger">
                                        {error.sonKullanimTarihi.message}
                                    </FormText>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="odemeTuru">Ödeme Türü</Label>
                                    <Select id="odemeTuru"
                                            name="odemeTuru"
                                            value={paymentType}
                                            disabled={this.props.currentUser.workType === 2 }
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e) => e && this.onSelect("odemeTuru", e.value)}
                                            options={this.paymentTypeList()}
                                    />
                                </FormGroup>
                            </Col>
                            {paymentType === 'TAKSIT' &&
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="taksitSayisi">Taksit Sayısı</Label>
                                    <Input type="text" className={error.taksitSayisi && error.taksitSayisi.className}
                                           pattern="\d+" onInput={this.onInput} value={layaways} name="taksitSayisi"
                                           id="taksitSayisi"/>
                                    {error.taksitSayisi &&
                                    <FormText className="text-danger">
                                        {error.taksitSayisi.message}
                                    </FormText>
                                    }
                                </FormGroup>
                            </Col>
                            }
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="faturaNo">Fatura Numarası</Label>
                                    <Input type="text"
                                           onChange={this.onChange}
                                           value={((this.props.currentUser.workType === 2) || (this.props.currentUser.distributor && this.props.currentUser.workType ===3)) ?"BAYIMUSTERIADINAODER":invoiceNumber}
                                           disabled={(this.props.currentUser.workType === 2) || (this.props.currentUser.distributor && this.props.currentUser.workType ===3)}
                                           name="faturaNo"
                                           id="faturaNo"/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <button type="button" onClick={this.toggleModal}
                            className=" TekBtn vazgec" style={{
                        background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                        padding: '9px 45px 9px 20px'
                    }}>Vazgeç
                    </button>
                    <div className="col-sm-6"></div>
                    {(this.props.currentUser.workType === 2) ?
                        <button type="button" onClick={this.onBuy} style={{padding: '9px 45px 9px 20px'}}
                                disabled={this.state.processing} className="  TekBtn kaydet pull-right"
                        >Satın Al</button>
                        :<button type="button" onClick={this.onSave} style={{padding: '9px 45px 9px 20px'}}
                                 disabled={this.state.processing} className="  TekBtn kaydet pull-right"
                        >Yükle</button>
                    }

                </ModalFooter>
            </Modal>
        )
    }

    quantityList(unitType) {
        switch (unitType) {
            case "FATURA_ADEDI":
            case "ARSIV_KASA":
                return this.state.amountList;
            case "ALAN_BOYUTU":
                return this.state.amountMbList;
            default:
                return [];
        }
    }
}


export default CreditModal;